$('.cta-wrap .btn').on('click', function () {
    $('html, body').animate({
        scrollTop: $("#orderNow").offset().top
    }, 1000);
})